<template>
  <b-card>
    <b-row>
      <!-- Tela -->
      <b-col cols="6">
        <b-form-group
          label-for="tour-virtual-type-helper"
        >
          <v-select
            key="value"
            v-model="filters.type_helper"
            :options="optionsHelperTour"
            :reduce="h => h.value"
            label="label"
            filterable
            clearable
            placeholder="Escolha a tela a ser filtrada"
            @input="handleInput($event)"
          />
        </b-form-group>
      </b-col>
      <b-col
        md="6"
        class="my-1"
      >
        <!--        button crear tour -->
        <b-button
          v-b-modal.modal-create-tour
          variant="primary"
          class="float-right"
        >
          Criar Tour
        </b-button>
        <b-modal
          id="modal-create-tour"
          title="Criar Tour"
          :ok-title="helper.id === null ? 'Salvar' : 'Atualizar'"
          @ok="handleOk"
          @cancel="handleCancel"
        >
          <b-form @submit.prevent>
            <b-row>
              <!-- Check Manual -->
              <b-col
                cols="12"
                class="d-flex justify-content-center"
              >
                <b-form-checkbox
                  id="check-manual"
                  v-model="helper.is_manual"
                  name="check-manual"
                  switch
                  inline
                  :value="1"
                  :unchecked-value="0"
                >
                  Manual
                </b-form-checkbox>
              </b-col>
              <!-- Tela -->
              <b-col
                v-if="helper.is_manual === 0"
                cols="12"
              >
                <b-form-group
                  label="Tela"
                  label-for="tour-virtual-type-helper"
                >
                  <v-select
                    key="value"
                    v-model="helper.type_helper"
                    :options="optionsHelperTour"
                    :reduce="h => h.value"
                    label="label"
                    filterable
                    clearable
                    placeholder="Tela que irar aparece o tour"
                  />
                </b-form-group>
              </b-col>
              <!-- Input Manual -->
              <b-col
                v-else
                cols="12"
              >
                <b-form-group
                  label="Tela"
                  label-for="tour-virtual-helper-manual"
                >
                  <b-input-group class="input-group-merge">
                    <b-form-input
                      id="tour-virtual-helper-manual"
                      v-model="helper.type_helper"
                      placeholder="Tela que irar aparece o tour"
                    />
                  </b-input-group>
                </b-form-group>
              </b-col>

              <!-- Titulo -->
              <b-col cols="12">
                <b-form-group
                  label="Titulo"
                  label-for="tour-virtual-title"
                >
                  <b-input-group class="input-group-merge">
                    <b-form-input
                      id="tour-virtual-title"
                      v-model="helper.title"
                      placeholder="Titulo"
                    />
                  </b-input-group>
                </b-form-group>
              </b-col>

              <!-- Conteudo -->
              <b-col cols="12">
                <b-form-group
                  label="Conteudo"
                  label-for="tour-virtual-conteudo"
                >
                  <b-input-group class="input-group-merge">
                    <b-form-input
                      id="tour-virtual-conteudo"
                      v-model="helper.content"
                      type="text"
                      placeholder="Conteudo"
                    />
                  </b-input-group>
                </b-form-group>
              </b-col>

              <!-- Target -->
              <b-col cols="12">
                <b-form-group
                  label="Target"
                  label-for="tour-virtual-target"
                >
                  <b-input-group class="input-group-merge">
                    <b-form-input
                      id="tour-virtual-target"
                      v-model="helper.target"
                      type="text"
                      placeholder="Target"
                    />
                  </b-input-group>
                </b-form-group>
              </b-col>

              <!-- Sequência -->
              <b-col cols="12">
                <b-form-group
                  label="Sequência"
                  label-for="tour-virtual-sequencia"
                >
                  <b-input-group class="input-group-merge">
                    <b-form-input
                      id="tour-virtual-sequencia"
                      v-model="helper.sequencia"
                      type="text"
                      placeholder="Sequência"
                    />
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col
                cols="12"
              >

                <b-form-group
                  label="Posição"
                  label-for="tour-virtual-type-helper"
                >
                  <b-form-select
                    v-model="helper.placement"
                    :options="[
                      {
                        value: null,
                        text: 'Selecione um tipo de tour'
                      },
                      {
                        value: 'top',
                        text: 'Top'
                      },
                      {
                        value: 'left',
                        text: 'Left'
                      },
                      {
                        value: 'right',
                        text: 'Right'
                      },
                      {
                        value: 'bottom',
                        text: 'Bottom'
                      }
                    ]"
                  />
                </b-form-group>
              </b-col>

              <!-- checkbox -->
              <b-col cols="6">
                <b-form-group class="d-flex justify-content-center">
                  <b-form-checkbox
                    id="enable_scrolling"
                    v-model="helper.enable_scrolling"
                    name="enable_scrolling"
                    :value="1"
                    :unchecked-value="0"
                  >
                    Habilitar a rolagem
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <!-- checkbox -->
              <b-col cols="6">
                <b-form-group class="d-flex justify-content-center">
                  <b-form-checkbox
                    id="highlight"
                    v-model="helper.highlight"
                    name="highlight"
                    :value="1"
                    :unchecked-value="0"
                  >
                    Destaque
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
        </b-modal>
      </b-col>

      <b-col
        cols="12"
        class="p-0"
      >
        <b-table
          hover
          responsive
          :per-page="perPage"
          :current-page="currentPage"
          :items="items"
          :fields="fields"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          :filter="filter"
          :filter-included-fields="filterOn"
          @filtered="onFiltered"
          @row-clicked="onRowSelected"
        >
          <template #cell(avatar)="data">
            <b-avatar :src="data.value" />
          </template>

          <template #empty="data">
            <b-alert show>
              Nenhum registro encontrado.
            </b-alert>
          </template>

          <template #cell(enable_scrolling)="data">
            {{ data.value === 0 ? 'Não' : 'Sim' }}
          </template>

          <template #cell(highlight)="data">
            {{ data.value === 0 ? 'Não' : 'Sim' }}
          </template>

          <template #cell(data_criacao)="data">
            {{ data.value | formatDateTimeBr }}
          </template>

          <template #cell(data_alteracao)="data">
            {{ data.value | formatDateTimeBr }}
          </template>

          <template #cell(ativo)="data">
            <b-badge :variant="status[1][data.value]">
              {{ status[0][data.value] }}
            </b-badge>
          </template>

          <template #cell(actions)="data">
            <b-button
              v-b-modal.modal-delete-helper-tour-virtual
              variant="danger"
              @click="idHelper = data.item.id"
            >
              <feather-icon icon="TrashIcon" />
            </b-button>
          </template>
        </b-table>
      </b-col>

      <b-col
        cols="12"
      >
        <b-pagination
          v-if="items.length > 0"
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          align="center"
          size="sm"
          class="my-0"
        />
      </b-col>
    </b-row>
    <modal-confirmation
      ref="modalConfirmation"
      title="Excluir Ação"
      id-modal="helper-tour-virtual"
      @okDeleteFluxoChat="deleteItem"
    >
      <template #content-message>
        <p>Tem certeza que deseja excluir esta ação?</p>
      </template>
    </modal-confirmation>
  </b-card>
</template>

<script>
import {
  BTable, BAvatar, BBadge, BRow, BCol, BFormGroup, BPagination, BInputGroup, BFormInput, BButton,
} from 'bootstrap-vue'
import VSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import ModalConfirmation from '@/components/ModalConfirmation.vue'
import { formatDateTimeBr } from '@core/utils/filter'

export default {
  components: {
    ModalConfirmation,
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BPagination,
    BInputGroup,
    BFormInput,
    BButton,
    VSelect,
  },
  filters: {
    formatDateTimeBr,
  },
  data() {
    return {
      isManual: false,
      filters: {
        type_helper: '',
      },
      helper: {
        id: null,
        title: '',
        conteudo: '',
        ativo: 1,
        target: '',
        placement: '',
        sequencia: '',
        type_helper: '',
        enable_scrolling: 0,
        highlight: 0,
        is_manual: 0,
      },
      idHelper: null,
      optionsHelperTour: [],
      perPage: 200,
      pageOptions: [3, 5, 10],
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      infoModal: {
        id: 'modal-create-tour',
        title: '',
        content: '',
      },
      fields: [
        {
          key: 'title', label: 'Titulo', sortable: true, sortDirection: 'desc',
        },
        { key: 'sequencia', label: 'Sequêmcia' },
        { key: 'type_helper', label: 'Tipo' },
        { key: 'enable_scrolling', label: 'Rolagem' },
        { key: 'highlight', label: 'Destaque' },
        {
          key: 'data_criacao', label: 'Data de criação', sortable: true, sortDirection: 'desc',
        },
        {
          key: 'data_alteracao', label: 'Data de alteração', sortable: true, sortDirection: 'desc',
        },
        { key: 'ativo', label: 'Status' },
        { key: 'actions', label: 'Ações' },
      ],
      items: [],
      status: [{
        0: 'Inativo', 1: 'Ativo', 2: 'Professional', 3: 'Rejected', 4: 'Resigned', 5: 'Applied',
      },
      {
        0: 'light-danger', 1: 'light-success', 2: 'light-success', 3: 'light-danger', 4: 'light-warning', 5: 'light-info',
      }],
    }
  },
  computed: {
    sortOptions() {
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
  },
  async mounted() {
    this.optionsHelperTour = this.$router.options.routes.map(item => ({ value: item.name, label: item.path }))
    this.totalRows = this.items.length
    await this.$store.dispatch('appHelperTour/findAll')
      .then(data => {
        this.items = data
      })
      .catch(error => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Erro',
            text: error,
            icon: 'EditIcon',
            variant: 'danger',
          },
        })
      })
  },
  methods: {
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`
      this.infoModal.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },
    deleteItem() {
      this.$store.dispatch('appHelperTour/deleted', { id: this.idHelper })
        .then(resp => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Sucesso',
              text: resp.message,
              icon: 'EditIcon',
              variant: 'success',
            },
          })
          this.items = this.items.filter(i => i.id !== this.idHelper)
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Erro',
              text: error,
              icon: 'EditIcon',
              variant: 'danger',
            },
          })
        })
    },
    resetModal() {
      this.infoModal.title = ''
      this.infoModal.content = ''
      this.helper = {
        id: null,
        title: '',
        conteudo: '',
        ativo: 1,
        target: '',
        placement: 'bottom',
        sequencia: 1,
        type_helper: '',
        enable_scrolling: 0,
        highlight: 0,
        is_manual: 0,
      }
      this.$nextTick(() => {
        this.$bvModal.hide('modal-create-tour')
        this.findAllList()
      })
    },
    handleInput() {
      if (this.filters.type_helper === null) {
        this.findAllList()
      } else {
        this.$store.dispatch('appHelperTour/findByTypeHelperTour', { typeHelperTour: this.filters.type_helper })
          .then(data => {
            this.items = data
          })
          .catch(error => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Erro',
                text: error,
                icon: 'EditIcon',
                variant: 'danger',
              },
            })
          })
      }
    },
    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault()
      this.handleSubmit()
    },
    findAllList() {
      this.$store.dispatch('appHelperTour/findAll', {
        type: this.filters.type_helper,
        transform: 0,
      })
        .then(data => {
          this.items = data
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Erro',
              text: error,
              icon: 'EditIcon',
              variant: 'danger',
            },
          })
        })
    },
    handleSubmit() {
      if (this.helper.id !== null) {
        this.$store.dispatch('appHelperTour/update', { data: this.helper, id: this.helper.id })
          .then(resp => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Atualização',
                text: resp.message,
                icon: 'EditIcon',
                variant: 'success',
              },
            })
            this.resetModal()
            this.findAllList()
          })
          .catch(error => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Erro',
                text: error,
                icon: 'EditIcon',
                variant: 'danger',
              },
            })
          })
      } else {
        this.$store.dispatch('appHelperTour/create', { data: this.helper })
          .then(resp => {
            this.$bvModal.hide('modal-create-tour')
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Criação',
                text: resp.message,
                icon: 'EditIcon',
                variant: 'success',
              },
            })
            this.resetModal()
            this.findAllList()
          })
          .catch(error => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Erro',
                text: error,
                icon: 'EditIcon',
                variant: 'danger',
              },
            })
          })
      }
    },
    handleCancel(bvModalEvt) {
      bvModalEvt.preventDefault()

      this.resetModal()
      this.$nextTick(() => {
        this.$bvModal.hide('modal-create-tour')
      })
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    onRowSelected(items) {
      this.helper = items
      this.$nextTick(() => {
        this.$bvModal.show('modal-create-tour')
      })
    },
  },
}
</script>
